// Parcours d'apprentissage structurés — Cabinet KEYTO
// Chaque parcours = une suite ordonnée d'étapes qui peuvent rediriger vers d'autres vues.

export const PARCOURS = [
  {
    id: "debutant",
    titre: "Découverte du PCG",
    sousTitre: "Pour les vrais débutants en comptabilité",
    duree: "≈ 45 min",
    niveau: "Débutant",
    color: "#2F7A5C",
    icon: "🌱",
    description:
      "Tu n'as jamais fait de compta et tu veux comprendre la logique d'ensemble. À la fin, tu sauras lire un compte, expliquer un débit/crédit et reconnaître les 8 classes.",
    etapes: [
      { titre: "Lis le glossaire", action: "Parcours les 31 définitions essentielles.", view: "glossaire", duree: "10 min" },
      { titre: "Comprends les 8 classes", action: "La logique d'organisation du PCG.", view: "logique", duree: "8 min" },
      { titre: "Suis la méthode KEYTO", action: "5 étapes pour passer n'importe quelle écriture.", view: "methodologie", duree: "10 min" },
      { titre: "Regarde l'animation", action: "Du journal au bilan : le flux comptable expliqué.", view: "flux", duree: "8 min" },
      { titre: "Quiz d'intégration", action: "10 questions pour vérifier les bases.", view: "quiz", duree: "8 min" },
    ],
  },
  {
    id: "intermediaire",
    titre: "Maîtriser les écritures du quotidien",
    sousTitre: "Pour les stagiaires et collaborateurs juniors",
    duree: "≈ 1h30",
    niveau: "Intermédiaire",
    color: "#2D6BE0",
    icon: "📘",
    description:
      "Tu connais les bases mais tu hésites encore sur le bon compte. À la fin, tu sauras enchaîner achats, ventes, TVA, paie sans trembler.",
    etapes: [
      { titre: "Méthode 5 étapes", action: "Révise la méthode KEYTO.", view: "methodologie", duree: "10 min" },
      { titre: "Catalogue d'écritures", action: "Lis les 24 schémas types (cycle Achats + Ventes).", view: "ecritures", duree: "20 min" },
      { titre: "Recherche en langage naturel", action: "Teste 5 cas concrets dans la recherche.", view: "recherche", duree: "10 min" },
      { titre: "Compare les comptes proches", action: "411 vs 416, 607 vs 4456, 6811 vs 28154.", view: "comparateur", duree: "10 min" },
      { titre: "Calculateurs TVA & amortissement", action: "Maîtrise les calculs auto.", view: "calculateurs", duree: "10 min" },
      { titre: "Exercices guidés", action: "3 exercices pas-à-pas.", view: "exercices", duree: "20 min" },
      { titre: "Quiz de niveau intermédiaire", action: "Valide tes acquis.", view: "quiz", duree: "10 min" },
    ],
  },
  {
    id: "dcg",
    titre: "Préparation DCG UE 9 / BTS CG",
    sousTitre: "Pour les étudiants en cursus comptable",
    duree: "≈ 4h (à étaler)",
    niveau: "Avancé",
    color: "#A33B4B",
    icon: "🎓",
    description:
      "Programme structuré pour préparer l'UE 9 du DCG ou le BTS CG. Couvre les opérations de clôture, amortissements, dépréciations, et la mécanique avancée.",
    etapes: [
      { titre: "Logique des 8 classes (révision)", action: "Verrouille la structure du PCG.", view: "logique", duree: "10 min" },
      { titre: "Catalogue complet des 24 écritures", action: "Étudie toutes les opérations courantes ET de clôture.", view: "ecritures", duree: "45 min" },
      { titre: "Flux journal → bilan (animation)", action: "Visualise l'imbrication des livres comptables.", view: "flux", duree: "10 min" },
      { titre: "Calculs : TVA, amortissement, ratios", action: "Maîtrise les calculs qui tombent en examen.", view: "calculateurs", duree: "20 min" },
      { titre: "Comparateur de comptes", action: "Pour les pièges classiques de l'examen.", view: "comparateur", duree: "15 min" },
      { titre: "Exercices guidés", action: "Tous les exercices KEYTO.", view: "exercices", duree: "60 min" },
      { titre: "Tous les quiz", action: "Validation finale.", view: "quiz", duree: "30 min" },
      { titre: "Agent IA pour les questions ouvertes", action: "Pose tes questions difficiles à l'IA.", view: "home", duree: "—" },
    ],
  },
];
